const config = {
    install(app /* , {store} */ ) {

        // const isProd = import.meta.env.NODE_ENV === 'production'
        const isProd =
            import.meta.env.PROD

        window.isProd = isProd

        // log('in config.js', app)

        app.mixin({

            props: { // Globals Props
                item: {
                    Object,
                    default: {}
                },
                items: {
                    Object,
                    default: {}
                },
            },

            // data() {
            //     return {
            //         test: 'this is a Test', //* OK
            //     }
            // },

            // inst: getCurrentInstance,

            //             setup(props, {attrs}){ !!! NON
            //                 attrs.$_isMobile = $_isMobile
            // log('in SETUP MIXIN', props, attrs)
            //                 // return attrs
            //             },


            //* FOR in TEMPLATES (and not in Setup's hooks...)
            computed: { // raccourcis à $page.props.

                // //~ $isProd(){ return process.env.NODE_ENV === 'production' },
                isProd() {
                    return isProd
                },

                $_() {
                    return _
                }, // lodash in Templates

                // app_state(){ return store.state.app },

                pp() {
                    /*  log('PP', this.$page.props); */
                    return this.$page.props
                }, // OK
                // pp(){ return props.initialPage.props }, // OK
                // pp(){ /* log('in config.js - PP', usePage().props.value); */ return usePage().props.value }, // OK

                user() {
                    /* log('in computed - PP', this.pp); */
                    return this.pp.user
                }, // OK

                // items(){ /* log('ITEMS',this.$page);  */return this.$page.props.items }, // OK
                // item(){ /* log('ITEM',this.$page); */ return this.$page.props.item }, // OK

                utils() {
                    return this.pp.utils
                }, // Traits/SetterDatas@getUtils()
                // userAddons() {
                //     return this.pp.userAddons  // Traits/GetUser@getUserAddons()
                // },

                isMaster() {
                    return this.pp.isMaster
                },
                isAdmin() {
                    return this.pp.isAdmin
                },
                isCarrier() {
                    return this.pp.isCarrier
                },
                isClient() {
                    return this.pp.isClient
                },
                isDriver() {
                    return this.pp.isDriver
                },
               

                // // flash(){ return this.pp.flash ? this.pp.flash : this.pp.jetstream.flash },
                // flash(){ return this.pp.flash || this.pp.jetstream.flash },


                // // vueVersion()    { return appCreate.version },
                vueVersion() {
                    return app.version
                },
                // laravelVersion(){ return this.pp.laravelVersion },
                // // inertiaVersion(){ return this.pp.inertiaVersion },
                // phpVersion()    { return this.pp.phpVersion },
            },

            methods: {

                log(...vars) {
                    return log(...vars)
                }, // util in <templates> - log() window function in bootstrap.js
            },

        })
    }
}
export default config
